const CASTALIA_TOKEN_KEY = "castalia.access_token"

export const readCastaliaToken = () => {
  if (typeof localStorage === "undefined") return undefined
  try {
    return localStorage.getItem(CASTALIA_TOKEN_KEY) ?? undefined
  } catch {
    return undefined
  }
}

export const writeCastaliaToken = (token: string) => {
  if (typeof localStorage === "undefined") return
  try {
    localStorage.setItem(CASTALIA_TOKEN_KEY, token)
  } catch {
    return
  }
}

export const readCastaliaTokenFromUrl = () => {
  const params = new URLSearchParams(location.search)
  const token = params.get("castalia_token")
  if (!token) return readCastaliaToken()
  writeCastaliaToken(token)
  params.delete("castalia_token")
  history.replaceState(null, "", location.pathname + (params.size ? `?${params}` : "") + location.hash)
  return token
}
